import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Chapter } from "@/components/Chapter";
import { POSTS } from "@/lib/posts";
import { formatDate } from "@/lib/markdown";
import { categoryImage } from "@/data/site";

export const BlogPreview = () => (
  <section id="blog" data-testid="section-blog" className="bg-clinic-tint/50 py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-5 md:px-8">
      <Reveal>
        <Chapter number="05" kicker="Guide" title="Cosa dice la norma, spiegato semplice" />
      </Reveal>

      <div className="grid gap-8 md:grid-cols-3">
        {POSTS.slice(0, 3).map((post, i) => (
          <Reveal key={post.slug} delay={i * 0.08}>
            <Link
              to={`/blog/${post.slug}`}
              data-testid={`blog-card-${post.slug}`}
              className="group flex h-full flex-col border border-ink/10 bg-paper transition-transform hover:-translate-y-1"
            >
              <div className="h-44 overflow-hidden border-b border-ink/10">
                <img
                  src={categoryImage(post.category)}
                  alt={`Medicina del lavoro — ${post.category}`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-7">
              <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-clinic mb-4">
                {post.category}
              </p>
              <h3 className="font-display text-xl md:text-2xl leading-snug text-ink group-hover:text-clinic transition-colors mb-4">
                {post.title}
              </h3>
              <p className="text-sm leading-relaxed text-ink/60 line-clamp-3 mb-6">
                {post.description}
              </p>
              <p className="mt-auto pt-4 font-mono text-[10px] tracking-[0.15em] uppercase text-ink/40">
                Agg. {formatDate(post.dateModified)} · {post.readingTime}
              </p>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <Link
          to="/blog"
          data-testid="blog-view-all"
          className="mt-10 inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.2em] uppercase text-clinic hover:gap-4 transition-all"
        >
          Tutti gli articoli <ArrowRight size={14} />
        </Link>
      </Reveal>
    </div>
  </section>
);
